var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',{attrs:{"label":_vm.label,"value":_vm.value,"color":"primary","title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }